import { accountsClient } from './account.init';
import { getClient } from '../core/apollo/client';
import { AuthorizationMiddleware } from '../core/network/authorization-middleware';
import { getUserQuery } from '../auth/graphql/getUser.query';

export const refreshSession = async () => {
  const tokens = await accountsClient.refreshSession();
  if (tokens) {
    AuthorizationMiddleware.setToken(tokens.accessToken);
  } else {
    AuthorizationMiddleware.setToken(null);
  }
  return tokens;
};

export const clearSession = async () => {
  try {
    await accountsClient.logout();
  } catch {
    // No active session to clear (e.g. wrong password on login).
  }
  AuthorizationMiddleware.setToken(null);
};

export const logout = async () => {
  await clearSession();
  window.location.reload();
};

export const login = async (username, password) => {
  const { tokens } = await accountsClient.loginWithService('password', {
    user: { username },
    password,
  });
  AuthorizationMiddleware.setToken(tokens.accessToken);
  return { tokens };
};

export const getUser = async () => {
  try {
    const response = await getClient().query({ query: getUserQuery });
    return response.data.getUser;
  } catch {
    return null;
  }
};
